import { render } from "./CourseEdit.vue?vue&type=template&id=29f4539c&scoped=true"
import script from "./CourseEdit.vue?vue&type=script&lang=js"
export * from "./CourseEdit.vue?vue&type=script&lang=js"

import "./CourseEdit.vue?vue&type=style&index=0&id=29f4539c&lang=scss&scoped=true"
import "./CourseEdit.vue?vue&type=style&index=1&id=29f4539c&lang=less&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f4539c"]])

export default __exports__